import { ExtendedSubscriptionInterval } from './extended-subscription-interval';
import { SubscriptionIntervalDisplayMode } from './subscription-interval-display-mode';

export interface SubscriptionIntervalParams {
  interval: ExtendedSubscriptionInterval;
  displayMode: SubscriptionIntervalDisplayMode;
}
